import {
  AutocompleteWithLabel,
  FreeSoloAutocompleteWithLabel
} from '@adotel/components'
import { useQuery } from '@apollo/client'
import { ButtonBase } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteIcon from '@material-ui/icons/Delete'
import { FormikErrors, FormikTouched } from 'formik'
import { useEffect, useState } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { GATEWAYS_LIST_QUERY } from '../../graphql/gateways'
import { getTranslate } from '../../localization'
import { Gateway } from '../../types/gateway'
import { AssociatedGateway, SiteKeyUpload } from '../../types/sitekey'
import { SiteKeyAssociatedGateway } from '../SitekeyFormEdit/SiteKeyAssociatedGateway'
import useStyles from './styles/SitekeyWBSDetails.styles'

interface SitekeyWBSDetailsProps {
  values: SiteKeyUpload
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  errors: FormikErrors<SiteKeyUpload>
  touched: FormikTouched<SiteKeyUpload>
  handleBlur: any
  isSubmitting: boolean
  associatedGateways: AssociatedGateway[]
  setAssociatedGateways: React.Dispatch<
    React.SetStateAction<AssociatedGateway[]>
  >
}

const SitekeyWBSDetails: React.FC<SitekeyWBSDetailsProps> = ({
  errors,
  touched,
  isSubmitting,
  handleBlur,
  values,
  setFieldValue,
  associatedGateways,
  setAssociatedGateways
}) => {
  const classes = useStyles()
  const [autoCompleteLabelGateways, setautoCompleteLabelGateways] = useState<
    any[]
  >([])

  const { loading: loadingForGateways, data: gatewaysData } = useQuery<{
    gateways: Gateway[]
  }>(GATEWAYS_LIST_QUERY)
  useEffect(() => {
    if (!gatewaysData) {
      return
    }
    const temp: any[] = []
    values?.AssociatedGateways.forEach((items) => {
      items.GatewayIds.forEach((value) => {
        temp.push({
          label: gatewaysData?.gateways.find(
            (gateway) => gateway.basicDetails.gatewayId === value
          )?.basicDetails.name,
          value: value
        })
      })
    })
    setautoCompleteLabelGateways(temp)
    setAssociatedGateways(values.AssociatedGateways)
  }, [values.AssociatedGateways, loadingForGateways])

  useEffect(() => {
    const temp: any[] = []
    associatedGateways.forEach((items) => {
      items.GatewayIds.forEach((value) => {
        temp.push({
          label: gatewaysData?.gateways.find(
            (gateway) => gateway.basicDetails.gatewayId === value
          )?.basicDetails.name,
          value: value
        })
      })
    })

    setautoCompleteLabelGateways(temp)
  }, [associatedGateways])

  return (
    <div>
      <SectionTitle title="WBS Details" marginBottom />
      <div className={classes.inputContainer}>
        <div>
          <FreeSoloAutocompleteWithLabel
            name="Hosts"
            label={getTranslate('Hosts')}
            placeholder={getTranslate('Enter the Host')}
            onChange={(_, v: any) => {
              setFieldValue('Hosts', v)
            }}
            options={[]}
            message={''}
            regexPattern={
              /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            }
            size="small"
            fullWidth
            value={values.Hosts}
            inputSize="small"
            error={(touched.Hosts && !!errors.Hosts) || undefined}
            onBlur={handleBlur}
            disabled={isSubmitting}
            limitTags={1}
          />
        </div>
        <div>
          <FreeSoloAutocompleteWithLabel
            // disabled={isSubmitting}
            name="CORSURLs"
            label={getTranslate('Cors URLs')}
            placeholder={getTranslate('Enter the Cors URL')}
            onChange={(_, v: any) => {
              setFieldValue('CORSURLs', v)
            }}
            options={[]}
            message={''}
            regexPattern={
              /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            }
            size="small"
            fullWidth
            value={values.CORSURLs}
            inputSize="small"
            error={(touched.CORSURLs && !!errors.CORSURLs) || undefined}
            onBlur={handleBlur}
            limitTags={1}
          />
        </div>
        <div />
        <div>
          <AutocompleteWithLabel
            name="AssociatedGateways"
            inputSize="small"
            multiple
            loading={loadingForGateways}
            loadingText={getTranslate('Loading') + '...'}
            options={
              gatewaysData?.gateways.map((item) => {
                return {
                  value: item.basicDetails.gatewayId,
                  label: item.basicDetails.name
                }
              }) || []
            }
            size="medium"
            label={getTranslate('Associated Gateways')}
            placeholder={getTranslate('Select the Associated Gateway')}
            value={autoCompleteLabelGateways}
            onChange={(_, v: any) => {
              const selectedGateways: string[] = []
              v.map((value: any) => selectedGateways.push(value.value))
              setFieldValue('AssociatedGateways', selectedGateways)
            }}
            onBlur={handleBlur}
            disabled
          />
        </div>
        <div />
        <div className={classes.buttonsContainer}>
          <ButtonBase
            className={[
              classes.greenColor,
              associatedGateways.length > 0 && classes.greyColor
            ].join(' ')}
            onClick={() => {
              setAssociatedGateways((preState) => {
                return [
                  ...preState,
                  {
                    Code: '',
                    GatewayType: '',
                    GatewayIds: []
                  }
                ]
              })
            }}
            disabled={associatedGateways.length > 0}>
            <AddCircleOutlineIcon />
          </ButtonBase>
          <ButtonBase className={classes.hide} disabled>
            <DeleteIcon />
          </ButtonBase>
        </div>
      </div>
      {associatedGateways.map((gw, index) => (
        <SiteKeyAssociatedGateway
          key={index}
          associatedGateways={associatedGateways}
          index={index}
          setAssociatedGateways={setAssociatedGateways}
          isDefault={gw.Code === 'Default'}
        />
      ))}
    </div>
  )
}
export default SitekeyWBSDetails
